module.exports = __webpack_public_path__ + "static/img/组 22.1ba152ad.png";